<script lang="ts">
	import NbackTest from "@/lib/nback/NbackTest.svelte";
</script>

<main>
	<NbackTest />
</main>
